import axios from "axios";
import { authHeader } from "../_helper/auth-header";



const rootUrl = 'https://server.venturesoul.in/api/v1/'
// const rootUrl = 'http://localhost:7117/api/v1/'


const authURL = rootUrl + 'account';
const newsURL = rootUrl + 'news';
const insightURL = rootUrl + 'insight';
const teamsURL = rootUrl + 'teams';
const leadershipURL = rootUrl + 'leadership';











/*********** Auth ***********/
async function login(loginData) {
  return await axios.post(authURL + '/admin/login', loginData);
}

async function getnews(limit, offset) {
  return await axios.get(newsURL + '?limit=' + limit + '&offset=' + offset);
}
async function addnews(data) {
  return await axios.post(newsURL, data, {
    headers: await authHeader(),
  });
}
async function updatenews(id, data) {
  return await axios.patch(newsURL + `/${id}`, data, {
    headers: await authHeader(),
  });
}
async function updateNewsImage(id, image) {
  return await axios.put(newsURL + '/' + id, { image }, {
    headers: await authHeader('FormData'),
  });
}
async function deleteNewsImage(id) {
  return await axios.delete(newsURL + '/' + id, {
    headers: await authHeader(),
  });
}


//INsights

async function getinsight(limit, offset, status) {
  return await axios.get(insightURL + '/admin?limit=' + limit + '&offset=' + offset + '&status='+status)
}
async function addinsight(data) {
  return await axios.post(insightURL, data, {
    headers: await authHeader(),
  });
}
async function updateinsight(id, data) {
  return await axios.patch(insightURL+ `/${id}`, data, {
    headers: await authHeader(),
  });
}

async function updateinsightImage(id, image) {
  return await axios.put(insightURL + '/' + id, { image }, {
    headers: await authHeader('FormData'),
  });
}
async function updateinsightPdf(id, image) {
  return await axios.put(insightURL + '/pdf/' + id, { image }, {
    headers: await authHeader('FormData'),
  });
}
async function updateInsightStatus(id, status) {
  return await axios.put(insightURL + '/status/' + id, { status }, {
    headers: await authHeader(),
  });
}
async function deleteInsight(id) {
  return await axios.delete(insightURL + '/' + id, {
    headers: await authHeader(),
  });
}

//Teams

async function getteams(status) {
  return await axios.get(teamsURL + `/admin?status=${status}`, {
    headers: await authHeader(),
  });
}
async function addteams(data) {
  return await axios.post(teamsURL, data, {
    headers: await authHeader(),
  });
}
async function updateteams(id, data) {
  return await axios.patch(teamsURL + `/${id}`, data, {
    headers: await authHeader(),
  });
}
async function updateteamsImage(id, image) {
  return await axios.put(teamsURL + `/image/${id}`, { image }, {
    headers: await authHeader('FormData'),
  });
}
async function updatepartnerImage(id, image) {
  return await axios.put(teamsURL + `/image/partner/${id}`, { image }, {
    headers: await authHeader('FormData'),
  });
}
async function updateTeamStatus(id, status) {
  return await axios.put(teamsURL + `/status/${id}`, { status }, {
    headers: await authHeader(),
  });
}
async function deleteTeam(id) {
  return await axios.delete(teamsURL + `/${id}`, {
    headers: await authHeader(),
  });
}



//Leadership

async function getLeadership(status) {
  return await axios.get(leadershipURL + `/admin?status=${status}`, {
    headers: await authHeader(),
  });
}
async function addLeadership(data) {
  return await axios.post(leadershipURL, data, {
    headers: await authHeader(),
  });
}
async function updateLeadership(id, data) {
  return await axios.patch(leadershipURL + `/${id}`, data, {
    headers: await authHeader(),
  });
}
async function updateLeadershipImage(id, image) {
  return await axios.put(leadershipURL + `/image/${id}`, { image }, {
    headers: await authHeader('FormData'),
  });
}
async function updateLeadershipIcon(id, image) {
  return await axios.put(leadershipURL + `/image/icon/${id}`, { image }, {
    headers: await authHeader('FormData'),
  });
}
async function updateLeadershipStatus(id, status) {
  return await axios.put(leadershipURL + `/status/${id}`, { status }, {
    headers: await authHeader(),
  });
}
async function deleteLeadership(id) {
  return await axios.delete(leadershipURL + `/${id}`, {
    headers: await authHeader(),
  });
}





export const service = {
  login,

  getnews, addnews, updateNewsImage, updatenews, deleteNewsImage,
  getinsight, addinsight,updateinsight , updateinsightImage, updateinsightPdf, updateInsightStatus, deleteInsight,

  getteams, addteams, updateteams, updateteamsImage, updatepartnerImage,updateTeamStatus,  deleteTeam,

  getLeadership, addLeadership, updateLeadership, updateLeadershipImage, updateLeadershipIcon,updateLeadershipStatus, deleteLeadership










}
